export default {
  // Load the company's prospects (summary records from the list endpoint).
  prospects(state, payload) {
    state.prospects = payload || [];
  },
  prospectsTimestamp(state) {
    state.prospectsTimestamp = String(Math.round(new Date().getTime() / 1000));
  },
  prospectsTimestampReset(state) {
    state.prospectsTimestamp = null;
  },
  prospectsLoading(state, payload) {
    state.prospectsLoading = payload === true;
  },
  // Paging and the per-stage totals, taken from the same list response.
  // `stageCounts` is computed server-side WITHOUT the stage filter applied,
  // so the board's column headers stay correct while a filter is active.
  prospectsPage(state, payload) {
    const page = payload || {};

    state.page = page.page || 1;
    state.pageSize = page.pageSize || state.pageSize;
    state.total = page.total || 0;
    state.stageCounts = page.stageCounts || {};
  },
  // A newly created prospect, so the board shows it without a refetch.
  prospectAdd(state, payload) {
    if (payload) {
      state.prospects = [payload, ...state.prospects];
    }
  },
  // Replace one prospect in place after a stage change, an upload or a
  // conversion, so the board reflects the server's response without
  // refetching the whole list.
  //
  // The server returns a FULL record from those endpoints while the list
  // holds summaries, so this merges rather than replaces: dropping the
  // extra keys would be lossy for a caller holding the full record, and
  // replacing wholesale would put jobPreferences and notes into the list
  // state, which is the data this module deliberately does not retain.
  prospectUpdate(state, payload) {
    if (!payload || !payload.prospectId) {
      return;
    }

    state.prospects = state.prospects.map((prospect) =>
      prospect.prospectId == payload.prospectId
        ? { ...prospect, ...payload }
        : prospect,
    );
  },
  prospectRemove(state, payload) {
    const prospectId = payload && payload.prospectId;

    if (!prospectId) {
      return;
    }

    state.prospects = state.prospects.filter(
      (prospect) => prospect.prospectId != prospectId,
    );
  },
  // Called on sign-out and on company switch: prospect data belongs to one
  // company and must not survive either.
  prospectsReset(state) {
    state.prospects = [];
    state.stageCounts = {};
    state.prospectsTimestamp = null;
    state.prospectsLoading = false;
    state.page = 1;
    state.total = 0;
  },
};
